/* ========================================================= * Material Kit 2 PRO React - v2.0.0 ========================================================= * Product Page: https://www.creative-tim.com/product/material-kit-pro-react * Copyright 2021 Creative Tim (https://www.creative-tim.com) Coded by www.creative-tim.com ========================================================= * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. */

import { useMaterialUIController } from "/context";
import dynamic from "next/dynamic";
import Head from "next/head";
import bannerImage from "/assets/img/bg-contact.jpg";
import config from '/config';

const MDBox = dynamic(() => import('/components/MDBox'), { loading: () => null });
const PageLayout = dynamic(() => import("/examples/PageLayout"), { loading: () => null });
const HeroBanner = dynamic(() => import('/examples/HeroBanner'), { loading: () => null });
const BodyCard = dynamic(() => import('/examples/BodyCard'), { loading: () => null });
const TurnYourVision = dynamic(() => import('/pageSections/Contact/TurnYourVision'), { loading: () => null });
const LetsStartADiscussion = dynamic(() => import('/pageSections/Contact/LetsStartADiscussion'), { loading: () => null });
const ContactUs = dynamic(() => import('/examples/ContactUs'), { loading: () => null });
const GoogleAnalytics = dynamic(() => import('/examples/GoogleAnalytics'), { loading: () => null });

function Contact() {
  const [controller] = useMaterialUIController();
  return (
    <>
      <Head>
        <title key="title">Contact Autumn Leaf</title>
        <meta name="description" content="Contact Long Island's Top Rated Landscaping Company for Outdoor Living, Cooking and Entertaining. (631) 424-5544" />
        <meta property="og:site_name" content="Autumn Leaf Landscape" />
        <meta property="og:url" content={`${config.frontURL}/contact`} />
        <meta property="og:title" content="Contact Autumn Leaf" />
        <meta property="og:description" content="Contact Long Island's Top Rated Landscaping Company for Outdoor Living, Cooking and Entertaining. (631) 424-5544." />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:image" content={`${config.frontURL}/images/social/contact-facebook.jpg`} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="photo" />
        <meta name="twitter:title" content="Contact Autumn Leaf" />
        <meta name="twitter:description" content="Contact Long Island's Top Rated Landscaping Company for Outdoor Living, Cooking and Entertaining. (631) 424-5544." />
        <meta name="twitter:url" content={`${config.frontURL}/contact`} />
        <meta name="twitter:image" content={`${config.frontURL}/images/social/contact-twitter.jpg`} />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              {
                "@context": "http://schema.org",
                "@type": "LocalBusiness",
                "name": "Autumn Leaf Landscape",
                "image": `${config.frontURL}/logo.png`,
                "telephone": "(631) 424-5544",
                "email": "lenny@autumnleaflandscape.com",
                "url": config.frontURL,
                "priceRange": "$$$",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "100 Centershore Rd",
                  "addressLocality": "Centerport",
                  "addressRegion": "NY",
                  "postalCode": "11721"
                },
                "openingHoursSpecification": {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": [
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday"
                  ],
                  "opens": "10:00",
                  "closes": "17:00"
                },
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "bestRating": 5,
                  "worstRating": 1,
                  "ratingValue": 5,
                  "reviewCount": 46
                }
              }
            )
          }}
        />
      </Head>
      <GoogleAnalytics />
      <PageLayout transparent light>
        <HeroBanner
          height="50vh"
          image={bannerImage.src}
          imageAlt="One of Autumn Leaf's outdoor design and build projects"
          prefix1="Contact us"
          prefix2=""
          typedJSContent={[]}
          subtitle=""
          buttons={["phone"]}
        />
        <BodyCard>
          <TurnYourVision />
          <LetsStartADiscussion />
        </BodyCard>
        <MDBox id="message">
          <ContactUs />
        </MDBox>
      </PageLayout>
    </>
  );
}

export default Contact;
